import { css } from 'lit';

export default css`
  .card-summary {
    display: flex;
  }

  .card-summary-content {
    flex-basis: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .card-summary-content > amityeko-tg-body-two::part(base) {
    color: var(--amityeko-color-gray-3);
  }

  .card-summary-content:last-child {
    border-left: 1px solid var(--amityeko-color-gray-8);
  }

  .cards {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
  }
`;
